import { render } from "./ServiceView.vue?vue&type=template&id=d8d2cab6"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__